import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "../../text";
import { Box } from "../../box";
import { useBlockComponentContext } from "../../form-blocks";
export const SectionRow = ({ translationKey }) => {
    const { Translated } = useBlockComponentContext();
    return (_jsx(Box, { flexDirection: "row", alignItems: "center", className: "sectionrow-0-44", children: _jsx(Text, { fontWeight: "bold", fontSize: "1.25em", style: { paddingLeft: 45 }, children: _jsx(Translated, { translationKey: translationKey }) }) }));
};
